<ng-container *ngIf="translations$ | async as translations">
  <div class="table-responsive mt-5">
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <ng-content *ngTemplateOutlet="header"></ng-content>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of currentItemsList; trackBy: identify">
          <ng-container
            *ngTemplateOutlet="body; context: { $implicit: item }"
          ></ng-container>
        </tr>
        <tr class="table-active">
          <td colspan="100%">
            <div class="footer">
              <div class="d-flex align-items-center pagination">
                <span
                  class="action"
                  [class.disabled]="startIndex === 0"
                  (click)="goToFirstPage()"
                  >«</span
                >
                <span
                  class="action"
                  [class.disabled]="startIndex === 0"
                  (click)="goToPreviousPage()"
                  >&lt;</span
                >
                <span class="page-indicator"
                  ><strong>{{ pageIndex }}</strong></span
                >
                <span
                  class="action"
                  [class.disabled]="isLastPage"
                  (click)="goToNextPage()"
                  >&gt;</span
                >
                <span
                  class="action"
                  [class.disabled]="isLastPage"
                  (click)="goToLastPage()"
                  >»</span
                >
              </div>
              <span class="float-right">
                {{ translations['Pages'] }}: <strong>{{ pageIndex }}</strong
                >/{{ totalPages }}
                <i
                  >({{ currentPageEntries }}/{{ totalItems }}
                  {{ translations['Entries'] }})</i
                >
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
